import type { AdmissionSaveErrorResponse } from '@/src/types/api.types'

/**
 * Thrown when /admissions/save responds with `error: true`.
 * Carries the full structured error payload from Aquisgrana.
 */
export class AdmissionSaveError extends Error {
  readonly returnCode: string
  readonly errorMessages: string[]

  constructor(response: AdmissionSaveErrorResponse) {
    super(response.message)
    this.name = 'AdmissionSaveError'
    this.returnCode = response.returnCode
    this.errorMessages = response.errorMessages
  }
}
